function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function() {
  return this.each(remove);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/remove.js
// module id = 410
// module chunks = 0 1 2 3 4